import { type UseQueryResult, useQuery } from 'react-query';
import { BrokerFixChannelSettingsService } from '@wealthlane/api-services/wealthlane-award-settlement-service';

export const isFixEngineEnabledForBrokerQueryKey = (brokerCompanyId: string) =>
  ['isFixEngineEnabledForBroker', brokerCompanyId] as const;

type UseGetIsFixEngineEnabledForBrokerOptions = {
  enabled?: boolean;
};

const useGetIsFixEngineEnabledForBroker = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  brokerCompanyId: string,
  options?: UseGetIsFixEngineEnabledForBrokerOptions
): UseQueryResult<boolean | undefined, unknown> => {
  const enabled = (options?.enabled ?? true) && Boolean(brokerCompanyId);

  const isFixEngineEnabledForBroker = useQuery(
    isFixEngineEnabledForBrokerQueryKey(brokerCompanyId),
    async () => {
      return await handleRequest(
        BrokerFixChannelSettingsService.getApiAwardSettlementApiAppBrokerFixChannelSettingsIsFixEngineEnabledForBroker(
          brokerCompanyId
        )
      );
    },
    { enabled }
  );
  return isFixEngineEnabledForBroker;
};

export default useGetIsFixEngineEnabledForBroker;
